import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { map, tap } from 'rxjs/operators';

import { ToastrService } from 'ngx-toastr';
import { JwtHelperService } from '@auth0/angular-jwt';

import { environment } from '../../../environments/environment';
import { AppConfig } from '../../app.config';
import { LogService } from '../log.service';
import { User } from '../security/user';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    // tslint:disable-next-line:object-literal-key-quotes
    'Accept': 'application/json'
  })
};
@Injectable()
export class SecurityService {
  private apiUrl = `${environment.api}/security`;
  private jwtService = new JwtHelperService();
  private user: User;

  constructor(
    private http: HttpClient,
    private logger: LogService,
    private toastr: ToastrService
  ) { }

  isInRole(role: string) {
    if (this.isAuthenticated()) {
      const token = this.decodeToken();
      if (token.role) {
        if (typeof token.role === 'string' || token.role instanceof String) {
          if (token.role === role) {
            return true;
          }
        } else if (typeof token.role === 'object' && token.role.constructor === Array) {
          const index = token.role.indexOf(role);
          if (index !== -1) {
            return true;
          }
        }
      }
    }
    return false;
  }

  decodeToken() {
    const user = JSON.parse(localStorage.getItem('currentUser')) as User;
    if (user && user.token) {
      const decodedToken = this.jwtService.decodeToken(user.token);
      return decodedToken;
    } else {
      return undefined;
    }
  }

  isAuthenticated(): boolean {
    const user = JSON.parse(localStorage.getItem('currentUser')) as User;
    console.log(user);
    if (user && user.token) {
      return true;
    }
    return false;
  }

  login(username: string, password: string, rememberMe: boolean, isAdminSite: boolean = true): Observable<boolean> {
    if (environment.online) {
      return this.http.post(this.apiUrl + '/login', { username, password, rememberMe, isAdminSite })
        .pipe(
          tap(() => {
            this.logger.log('Security Service', 'trying to login');
          }),
          map((user: User) => {
            if (user && user.token) {
              // store user details and jwt token in local storage to keep user logged in between page refreshes
              localStorage.setItem('currentUser', JSON.stringify(user));
              return true;
            } else {
              this.toastr.warning('لم يتم قبول عضويتك بعد', 'عفوا');
              return false;
            }
          })
        );
    } else {
      const user = { username };
      localStorage.setItem('currentUser', JSON.stringify(user));
      return of(true);
    }
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
  }

  jwtHeaders() {
    const currentUser: User = JSON.parse(localStorage.getItem('currentUser')) as User;
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // tslint:disable-next-line:object-literal-key-quotes
        'Accept': 'application/json',
        // tslint:disable-next-line:object-literal-key-quotes
        'Authorization': 'Bearer ' + currentUser.token
      })
    };
  }
}
